import BestPracticesSimulation from "../screens/best_practices_simulation/BestPracticesSimulation";
import ProductSummary from "../screens/productSummary/ProductSummary";
import { adminAccess, userAccess } from "./useRoleAccess";

export const ProductSummaryRoutes = [
  {
    path: "/product-summary",
    route: <ProductSummary />,
    protectRoutes: true,
    roleGrantAccess: [...adminAccess, ...userAccess]
  },
  {
    path: "suggestions",
    route: <BestPracticesSimulation />,
    protectRoutes: true,
    roleGrantAccess: [...adminAccess, ...userAccess]
  }
];
